<template>
  <div id="app" :class="{ 'is-overflow': currentRouteIsGallery }">
    <app-navbar v-if="!currentRouteIsHome"/>

    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>

  </div>
</template>

<script>
import appNavbar from './components/partials/navbar'

export default {
  components: {
    appNavbar
  },

  name: 'app',

  computed: {
    currentRouteIsHome () {
      return this.$route.path === '/'
    },

    currentRouteIsGallery () {
      if (
        this.$route.path === '/wolves-101/meet-the-wolf/' ||
        this.$route.path === '/wolves-101/pack-anatomy/' ||
        this.$route.path === '/wolves-101/social-behavior/' ||
        this.$route.path === '/wolves-101/value-of-having-wolves/' ||
        this.$route.path === '/wolves-101/wolves-and-people/'
        ) {
        return true
      } else {
        return false
      }
    }
  },

  beforeCreate () {
    this.$store.dispatch('getLocalData', 'shared')
  }
}
</script>

<style lang="scss">
#app {
  position: relative;
  &.is-overflow {
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue